import { Helmet } from 'react-helmet-async';
import "./Chapel.css"
import "../../ParafiaWizytowka.css"
import ChapelCard from "./component/ChapelCard";
import {chapels} from "../../data/chapelData.js"
import Invitation from "../../components/Invitation/Invitation.js";

const Chapel = () => {
  const getNabozenstwaOpis = () => {
    const nazwy = chapels.map(item => item.title).join(', ');
    return `Nabożeństwa w parafii: ${nazwy}. Sprawdź godziny i terminy nabożeństw różańcowych, majowych, gorzkich żali i innych.`;
  };

  return (
    <>
      <Helmet>
        <title>Nabożeństwa – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={getNabozenstwaOpis()} />
        <meta name="keywords" content="nabożeństwa, różaniec, nabożeństwo majowe, gorzkie żale, droga krzyżowa, adoracja, św. Urszula Ledóchowska, Częstochowa" />
        <meta property="og:title" content="Nabożeństwa – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content="Sprawdź terminy i godziny nabożeństw w naszej parafii. Różaniec, nabożeństwo majowe, gorzkie żale i inne." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Nabożeństwa – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content="Terminy i godziny nabożeństw w parafii św. Urszuli Ledóchowskiej w Częstochowie." />
      </Helmet>

      <section>
        <div className="container">
          <img 
            src="/assets/church_3537258.png" 
            alt="Ikona kościoła – nabożeństwa" 
            className="image" 
            title="Ikona autorstwa Triangle Squad"
          />
          <div>
            {chapels.map((item, index) => (
              <ChapelCard key={index} title={item.title} events={item.events} />
            ))}
          </div>
          <br/>
          <Invitation/>
        </div>
      </section>
    </>
  );
};

export default Chapel;